// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".youtube-dialog iframe{display:block}.youtube-dialog .v-card__title{display:none!important}.youtube-dialog .v-card__text{padding:0!important}", ""]);
// Exports
module.exports = exports;
